// ================= ProfProfile.jsx =================
import React, { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';

const ProfProfile = ({ user, updateUser }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     fullname: user.fullname || '',
//     email: user.email || '',
//     phone: user.phone || '',
//     address: user.address || '',
//     department: user.department || '',
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       // Simulation update backend
//       updateUser(formData);
//       toast.success('Profil mis à jour !');
//       setIsModalOpen(false);
//     } catch {
//       toast.error('Erreur lors de la mise à jour');
//     }
//   };

  return (
    <div style={styles.container}>
      <Toaster position="top-right" />
      <h1>Profil Professeur</h1>
      <div style={styles.infoBox}>
        {/* <p><strong>Nom complet:</strong> {user.fullname}</p>
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>Téléphone:</strong> {user.phone}</p>
        <p><strong>Adresse:</strong> {user.address}</p>
        <p><strong>Département:</strong> {user.department}</p> */}
         <p><strong>Nom complet:</strong>xxx</p>
        <p><strong>Email:</strong> xx</p>
        <p><strong>Téléphone:</strong> xx</p>
        <p><strong>Adresse:</strong> xx</p>
        <p><strong>Département:</strong> xx </p>
        <button style={styles.button} onClick={() => setIsModalOpen(true)}>Modifier le profil</button>
      </div>

      {/* {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h2>Modifier le profil</h2>
            <form onSubmit={handleSubmit} style={styles.form}>
              <input type="text" placeholder="Nom complet" required
                value={formData.fullname}
                onChange={(e) => setFormData({ ...formData, fullname: e.target.value })} />

              <input type="email" placeholder="Email" required disabled
                value={formData.email} />

              <input type="text" placeholder="Téléphone" required
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />

              <input type="text" placeholder="Adresse" required
                value={formData.address}
                onChange={(e) => setFormData({ ...formData, address: e.target.value })} />

              <input type="text" placeholder="Département" required
                value={formData.department}
                onChange={(e) => setFormData({ ...formData, department: e.target.value })} />

              <div style={styles.modalButtons}>
                <button type="submit" style={styles.button}>Enregistrer</button>
                <button type="button" style={{...styles.button, backgroundColor:'#dc2626'}} onClick={() => setIsModalOpen(false)}>Annuler</button>
              </div>
            </form>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default ProfProfile;

const styles = {
  container: { padding: '30px', fontFamily: 'Segoe UI, sans-serif' },
  infoBox: { background: '#f1f5f9', padding: '20px', borderRadius: '12px', maxWidth: '500px' },
  button: { padding: '10px 16px', marginTop: '15px', border: 'none', borderRadius: '6px', backgroundColor: '#2563eb', color: '#fff', cursor: 'pointer' },
  modalOverlay: { position: 'fixed', top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(0,0,0,0.5)', display:'flex', justifyContent:'center', alignItems:'center' },
  modal: { background:'#fff', padding:'30px', borderRadius:'12px', width:'400px' },
  form: { display:'flex', flexDirection:'column' },
  modalButtons: { display:'flex', justifyContent:'space-between', marginTop:'15px' },
};
